// extracted by mini-css-extract-plugin
export var typingIndicator = "_pt-0";